import * as css from './icon.css';

const withIconProps = (color: string, icon?: string, size?: number) => ({
    ...(color && {$color: color}),
    ...(icon && {$icon: icon}),
    ...(size && {$size: size})
});

function StatusIcon ({icon, color, size = 39}: {icon: string, color: string; size?: number}) {

    const props = withIconProps(color, icon, size);
    return (
        <css.IconOuterCircle  {...props}>
            <css.IconMiddleCircle  {...props}>
                <css.IconInnerCircle {...props}>             
                    <css.IconSymbol  {...props} />
                </css.IconInnerCircle>
            </css.IconMiddleCircle>
        </css.IconOuterCircle>
    );
}

export default StatusIcon;